import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classnames from 'classnames';
import { canUserNotPermission, canUpdateGoogleDriveDeleteLogic } from '../authorizations';
import { getGoogleDriveFileId } from '../util/googleDriveUtils';

import AnimationMarkerForm from './AnimationMarkerForm';
import AnimationMarkersInPlayer from './AnimationMarkersInPlayer';
import AnimationMarkerPointsDisplay from './AnimationMarkerPointsDisplay';
import AnimationMarkersToggler from './AnimationMarkersToggler';
import MarkShape from './MarkShape';
import {getStyleOfSize} from "../util/getStyleofSize"
import { styles } from "../util/styleDrawComponent";
import PolyLineSvg from "./PolyLineSvg";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, NavLink } from 'reactstrap';
import { fetchHeightHeader } from '../shared';
import CommentDetail from './CommentDetail';
import GdriveFileDeletedModal from './GdriveFileDeletedModal'
import { COMMENT_BOX_OPENED_EVENT, createCommentBoxSyncId, announceCommentBoxOpened } from '../util/animation-marker';

const showSVGIndex = 1000;
const hideSVGIndex = -1;


const markersVisibilities = ['all', 'circle', 'none'];

export default class AnimationImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTime: 0,
      isMarking: false,
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      currentWidth: 0,
      currentHeight: 0,
      currentShape: 'point',
      shouldShowForm: false,
      markersVisibility: 'all',
      temp: false,
      changeCss: false,
      canvasWidth: 0,
      canvasHeight: 0,
      zIndexSvg: hideSVGIndex,
      listItemSvg: [],
      currentItemSvg: null,
      settingDraw: {
        color: 'black',
        lineWidth: 3
      },
      canvasPositionImgs: [],
      currentCanvasWidth: 0,
      currentCanvasHeight: 0,
      isShowModalNotCompareVersion: false,
      timestamp: new Date().getTime(),
      loadingText: null,
      isLoading: false,
      shouldShowGdriveFileDeletedModal: false,
    };
    // this.overlayComponent = this.overlay()
    this.onImgLoad = this.onImgLoad.bind(this);
    this.commentBoxSyncId = createCommentBoxSyncId('animation-image');
  }

  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
    document.removeEventListener(COMMENT_BOX_OPENED_EVENT, this.handleCommentBoxOpened);
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);
    document.addEventListener(COMMENT_BOX_OPENED_EVENT, this.handleCommentBoxOpened);

    this.reset();
    // window.addEventListener("resize", this.update);
    const {currentAnimation} = this.props;
    const canOpenModal = currentAnimation?.additional_info?.gdrive_pdf ||( currentAnimation?.additional_info?.gdrive_file && currentAnimation?.additional_info?.gdrive_image == undefined)
    if(canOpenModal && canUpdateGoogleDriveDeleteLogic(this.props.role) && this.props.mainAdmin) {
      const event = new CustomEvent('gdriveFileDeletedModalLoaded', {'detail': currentAnimation?.additional_info?.handle_delete});
      document.dispatchEvent(event);
    } else {
      const event = new CustomEvent('gdriveFileDeletedModalUnLoaded');
      document.dispatchEvent(event);
    }
  }

  componentWillMount() {
    Shared.loadingIndicator()
  }

  update = () => {
    let width = document.getElementById("animation-image").offsetWidth;
    let height = document.getElementById("animation-image").offsetHeight;
    if (width !== this.state.canvasWidth){
      this.setState({
        canvasWidth: width,
        canvasHeight: height,
        listItemSvg: []
      }, () => {
        this.ctx = this.canvas.getContext("2d");
        this.ctx.clearRect(0, 0, this.state.canvasWidth, this.state.canvasHeight);
        this.ctx.drawImage(
          this.img,
          0,
          0,
          this.state.canvasWidth,
          this.state.canvasHeight
        );
      });
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      settingDraw: newProps.settingDraw,
    });
  }

  componentDidUpdate(newProp) {
    if (newProp.changeCss != this.props.changeCss) {
      this.setState({
        changeCss: newProp.changeCss
      })
    }

  }

  handleCommentBoxOpened = (event) => {
    if (event.detail?.sourceId === this.commentBoxSyncId) return;

    this.setState({
      shouldShowForm: false,
      isMarking: false,
    });
  }

  openMarkerForm = (nextState = {}, callback) => {
    this.props.updateSelectedMarker(null);
    announceCommentBoxOpened(this.commentBoxSyncId);
    this.setState({
      shouldShowForm: true,
      isMarking: false,
      ...nextState,
    }, callback);
  }

  mouseRelativeXY(event) {
    return this.relativeXY(event.clientX, event.clientY);
  }
  mouseRelativeXYDraw(event) {
    return this.relativeXY(
      event.nativeEvent.clientX,
      event.nativeEvent.clientY
    );
  }
  touchRelativeXY(event) {
    return this.relativeXY(event.touches[0].clientX, event.touches[0].clientY);
  }
  relativeXY(eventX, eventY) {
    const playerRect = findDOMNode(this.image).getBoundingClientRect();
    return [
      (eventX - playerRect.left) / playerRect.width * 10000,
      (eventY - playerRect.top) / playerRect.height * 10000,
    ];
  }
  startMark = ({ x, y }) => {
    if (!this.props.isCommentMode) return;
    /* FIX 20260717-dbltap: 切替直後は点も作らない（次の操作から囲えるようにする） */
    if (this._isJustEnteredCommentMode()) return;
    this.setState({
      isMarking: true,
      shouldShowForm: false,
      startX: x,
      startY: y,
      currentX: x,
      currentY: y,
      currentWidth: 0,
      currentHeight: 0,
      currentShape: 'point'
    });
  }
  moveMark = ({ x, y }) => {
    const { isMarking, startX, startY } = this.state;
    if (!isMarking) return;
    const { max, abs } = Math;
    const distance = max(abs(x - startX), abs(y - startY));
    distance > 10 && startX < x && startY < y
      ? this.setState({
        currentWidth: max(x - startX, 0),
        currentHeight: max(y - startY, 0),
        currentShape: 'rect',
      })
      : this.setState({
        currentWidth: 0,
        currentHeight: 0,
        currentShape: 'point',
      })
  }
  // ダブルクリック判定用
  _lastTapTime = 0;
  _DOUBLE_TAP_MS = 300;

  _showTapHint = () => {
    let toast = document.getElementById('tm-mode-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tm-mode-toast';
      toast.style.cssText = [
        'position:fixed', 'top:0', 'left:0',
        'transform:translate(-50%,-50%)',
        'background:rgba(0,0,0,0.75)', 'color:#fff',
        'padding:10px 18px', 'border-radius:8px',
        'font-size:13px', 'pointer-events:none',
        'z-index:2147483647', 'white-space:nowrap',
        'opacity:0', 'transition:opacity 0.2s'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = 'ダブルクリックするとコメントモードに切り替わります';
    const _getMediaRect = () => {
      try {
        const root = findDOMNode(this);
        const el = root ? root.querySelector('.wrap-animation-preview') || root : null;
        return el ? el.getBoundingClientRect() : null;
      } catch(e) { return null; }
    };
    const rect = _getMediaRect();
    if (rect) {
      toast.style.top = (rect.top + rect.height / 2) + 'px';
      toast.style.left = (rect.left + rect.width / 2) + 'px';
    } else {
      toast.style.top = '50%';
      toast.style.left = '50%';
    }
    toast.style.opacity = '1';
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => { toast.style.opacity = '0'; }, 1000);
  };

  _showModeToast = (text) => {
    let toast = document.getElementById('tm-mode-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tm-mode-toast';
      toast.style.cssText = [
        'position:fixed', 'top:0', 'left:0',
        'transform:translate(-50%,-50%)',
        'background:rgba(0,0,0,0.75)', 'color:#fff',
        'padding:10px 18px', 'border-radius:8px',
        'font-size:13px', 'pointer-events:none',
        'z-index:2147483647', 'white-space:nowrap',
        'opacity:0', 'transition:opacity 0.2s'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    const _getMediaRect = () => {
      try {
        const root = findDOMNode(this);
        const el = root ? root.querySelector('.wrap-animation-preview') || root : null;
        return el ? el.getBoundingClientRect() : null;
      } catch(e) { return null; }
    };
    const rect = _getMediaRect();
    if (rect) {
      toast.style.top = (rect.top + rect.height / 2) + 'px';
      toast.style.left = (rect.left + rect.width / 2) + 'px';
    } else {
      toast.style.top = '50%';
      toast.style.left = '50%';
    }
    toast.style.opacity = '1';
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => { toast.style.opacity = '0'; }, 1000);
  };

  /* FIX 20260717-dbltap: ダブルタップでコメントモードに切り替わった直後は、
     指を離した勢いでBOXを開かせない（開くと赤入れが「点」になり、囲って範囲指定できない）。
     従来は使い捨てフラグだったが、iPadは指を離した後 onTouchEnd→onMouseUp と
     複数回 endMark が走るため1回で消費され、2回目がすり抜けていた。
     時刻で判定し、切替から400msの間は何度呼ばれても開かない。 */
  _enterCommentModeAt = 0;
  _ENTER_GUARD_MS = 400;

  _isJustEnteredCommentMode = () => {
    return (Date.now() - this._enterCommentModeAt) < this._ENTER_GUARD_MS;
  };

  _showCommentMode = () => {
    this._enterCommentModeAt = Date.now();
    this._justEnteredCommentMode = true;
    setTimeout(() => { this._justEnteredCommentMode = false; }, this._ENTER_GUARD_MS);
    if (this.props.onEnterCommentMode) this.props.onEnterCommentMode();
  };

  endMark = (event) => {
    if (!this.props.isCommentMode) return;
    /* FIX 20260717-dbltap: 切替直後は開かない（フラグは消さない＝複数回呼ばれても効く） */
    if (this._isJustEnteredCommentMode()) {
      this.setState({ isMarking: false, shouldShowForm: false });
      try { event.stopPropagation(); event.preventDefault(); } catch(_) {}
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    const { currentAnimationId, animationSelectCurrent, toggleShowModalInputInfoOfNotLogin, isInputInfoMationOfNotLogin }= this.props;
    if (currentAnimationId === animationSelectCurrent) {
      if (gon.is_login || isInputInfoMationOfNotLogin) {
        this.openMarkerForm();
      } else {
        this.setState({ isMarking: false, });
        toggleShowModalInputInfoOfNotLogin();
      }
      this.disableMmount();
    }
  }
  disableMmount(e = '') {
    var menus = document.querySelectorAll('.show-mark-shape');
    menus = [].slice.call(menus);
    menus.forEach(function (element) {
      element.style.pointerEvents = e;
    });
  }
  onSubmitMarkerForm = (body, files, editorSetting) => {
    const { onSubmitMarkerForm } = this.props;
    const { currentX: x, currentY: y, currentWidth: width, currentHeight: height, currentShape: shape, currentTime: time } = this.state;
    return onSubmitMarkerForm({ body, x, y, width, height, shape, time, files, editorSetting }).then(() => this.setState({ shouldShowForm: false }));
  }
  onCloseMarkerForm = () => {
    this.setState({
      shouldShowForm: false,
    }, () => {
      this.ctx = this.canvas.getContext("2d");
      this.ctx.clearRect(0, 0, this.state.canvasWidth, this.state.canvasHeight);
      this.ctx.drawImage(
        this.img,
        0,
        0,
        this.state.canvasWidth,
        this.state.canvasHeight
      );
    })
  }
  onImgLoad({ target: img }) {
    $('.preloader').fadeOut();
    const { getHeightAnimaiton } = this.props;
    this.setState({
      canvasHeight: img.offsetHeight,
      canvasWidth: img.offsetWidth,
      currentCanvasWidth: img.offsetWidth,
      currentCanvasHeight: img.offsetHeight
    });
    getHeightAnimaiton(img.offsetHeight);
  }
  // [2026-06-29] ❹ ペン切替時に残るテキストの仮マーカーを片付ける（reset丸ごとは呼ばない=副作用なし）
  clearTempMarker() {
    this.setState({
      isMarking: false,
      shouldShowForm: false,
      currentX: 0, currentY: 0,
      currentWidth: 0, currentHeight: 0,
      currentShape: 'point',
      startX: 0, startY: 0,
    });
  }

  draw(e) {
    this.setState({
      isDel: false,
      shouldShowForm: false,
    });
    const canvas = this.canvas;
    const context = canvas.getContext("2d");
    context.drawImage(
      this.img,
      0,
      0,
      this.state.currentCanvasWidth,
      this.state.currentCanvasHeight,
    );
    this.setState({
      zIndexSvg: showSVGIndex,
    });
  }

  eraser() {
    this.setState({
      isDel: true,
    });
  }

  capture(e) {
    const fileDrawName = `draw-image-${moment.now()}`;
    const files = [];
    var svgURL = new XMLSerializer().serializeToString(this.svg);
    const canvas = this.canvas;
    const context = canvas.getContext("2d");
    var img = new Image();
    img.onload = () => {
      context.drawImage(
        img,
        0,
        0,
        this.state.canvasWidth,
        this.state.canvasHeight
      );
      var imageSrc = this.canvas.toDataURL();
      const { listItemSvg} = this.state;
      if (listItemSvg.length === 0) {
        return;
      } else {
       const {listItemSvg} = this.state
       const target = this.state.currentItemSvg || listItemSvg[0]
           const arr = target.capturePoint.split(",")
       const convertArr = arr[1].trim().split(' ')
       const markPointCaptureY = Number(convertArr[0])
       const markPointCaptureX = Number(convertArr[1])
       this.setState({
         currentX: markPointCaptureX,
         currentY: markPointCaptureY
       })
      }
      this.urltoFile(imageSrc, fileDrawName, "image/png").then((file) => {
        files.push(file);
        this.openMarkerForm(
          {
            currentShape: "draw",
            currentTime: 0,
          },
          () => {
            this.makerForm.onFileChange(null, files);
          }
        );
      });
    };
    img.src = "data:image/svg+xml; charset=utf8, " + encodeURIComponent(svgURL);
  }

  urltoFile(url, filename, mimeType) {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }

  deleteAllDraw() {
    this.setState({
      isDel: false,
      listItemSvg: [],
      shouldShowForm: false,
      zIndexSvg: hideSVGIndex,
    });
  }

  reset(isDelete) {
    if(!isDelete){
      this.setState({
        isDraw: false,
        isDel: false,
        zIndexSvg: hideSVGIndex,
        listItemSvg: [],
        shouldShowForm: false,
      });
    } else {
      this.setState({
        isDraw: false,
        isDel: false,
        shouldShowForm: false,
      });
    }
    this.ctx = this.canvas.getContext("2d");
    this.ctx.fillStyle = "transparent";
    this.ctx.clearRect(0, 0, this.state.canvasWidth, this.state.canvasHeight);
    this.ctx.drawImage(
      this.img,
      0,
      0,
      this.state.canvasWidth,
      this.state.canvasHeight
    );
    // [2026-06-29] 保存後もペンモードを維持する修正（依頼1・2）
    // ペンモード中のみ: ペン面を正寸・前面に戻し、番号付き赤丸を隠す
    if (this.props.isShowDrawComponent && this.img) {
      const _h = this.img.offsetHeight;
      const _w = this.img.offsetWidth;
      setTimeout(() => {
        this.setState({
          canvasHeight: _h,
          canvasWidth: _w,
          currentCanvasHeight: _h,
          currentCanvasWidth: _w,
          zIndexSvg: showSVGIndex,
        });
      }, 50);
    }
  }

  disableScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    window.onscroll = function() {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  enableScroll() {
    window.onscroll = function() {};
  }

  onMouseDown(event, isMobile) {
    const { mobile } = this.props;
    if (!this.props.changeCss || this.props.isShowDrawComponent) {
      if (mobile || platform.product === "iPad") {
        document.getElementById("animation-preview").style["overflow"] ="hidden";
        document.body.style.overflow = "hidden";
      } else {
        // document.getElementById("animation-preview").style["overflow"] ="auto";
        document.body.style.overflow = "auto";
      }
      if (!this.state.isDraw && !this.state.isDel) {
        this.setState({
          isDraw: true,
        });
        var newItem = {
          id: Date.now(),
          points: "",
          color: this.state.settingDraw.color,
          lineWidth: this.state.settingDraw.lineWidth,
          capturePoint: ""
        };
        if (!isMobile){
          var [x, y] = this.mouseRelativeXYDraw(event);
          newItem.capturePoint = ` , ${y} ${x}`
        } else {
          var [x, y] = this.touchRelativeXY(event);
          newItem.capturePoint = ` , ${y} ${x}`
          this.disableScroll();
        }
        this.setState({
          listItemSvg: [...this.state.listItemSvg, newItem],
          currentItemSvg: newItem,
        });
      }
    }
  }

  onMouseMove = (event, isMobile) => {
    if (!this.props.changeCss || this.props.isShowDrawComponent) {
      if (this.state.isDraw) {
        let heightTopToAnimation = fetchHeightHeader();
        var item = document.getElementById(this.state.currentItemSvg.id);
        var points = item.getAttribute("points");
        var capturePoint = item.getAttribute("capturePoint");
        if (!isMobile) {
          let pointsX = event.nativeEvent.layerX;
          let pointsy = event.nativeEvent.layerY
          pointsX = (pointsX * this.state.currentCanvasWidth / this.img.offsetWidth).toFixed()
          pointsy = (pointsy *  this.state.currentCanvasHeight / this.img.offsetHeight).toFixed()
          points += ` ${pointsX}, ${pointsy}`;
          var [x, y] = this.mouseRelativeXYDraw(event);
          capturePoint += ` ${x}, ${y}`;
        } else {
          var [x, y] = this.touchRelativeXY(event);
          capturePoint += ` ${x}, ${y}`;
          var _imgRect = findDOMNode(this.image).getBoundingClientRect();
          var _pointsX = ((event.touches[0].clientX - _imgRect.left) / _imgRect.width * this.state.currentCanvasWidth).toFixed();
          var _pointsY = ((event.touches[0].clientY - _imgRect.top) / _imgRect.height * this.state.currentCanvasHeight).toFixed();
          points += ` ${_pointsX}, ${_pointsY}`;
        }
        let itemInList = this.state.listItemSvg.find(
          (obj) => obj.id === this.state.currentItemSvg.id
        );
        if (itemInList) {
          itemInList.points = points;
          itemInList.capturePoint = capturePoint;
        }
        item.setAttribute("points", points);
        item.setAttribute("capturePoint", capturePoint);
      }
    }
  };

  onMouseUp() {
    document.body.style.overflow = "auto";
    if (this.props.changeCss) {
      document.getElementById("animation-preview").style["overflow"] ="auto";
    }
    if (this.state.isDraw) {
      this.setState({
        isDraw: false,
      });
      this.enableScroll();
    }
  }

  onItemMouseOver(event) {
    const { mobile } = this.props;
    const polyWidht = event.target.getBBox().width;
    const polyHeight = event.target.getBBox().height;
    if (mobile ){
      return
    } else if (platform.product === 'iPad'){
      return
    } else {
      if (!this.state.isDraw && this.state.isDel) {
        event.target.setAttribute("stroke-dasharray", "5 5");
        if (polyWidht <= 35 && polyHeight <= 35) {
          let id = event.target.getAttribute("id");
          let newLists = this.state.listItemSvg.filter((obj) => obj.id != id);
          this.setState({
            listItemSvg: newLists,
          });
        }
      }
    }
  }

  onItemMouseLeave(event) {
    if (!this.state.isDraw && this.state.isDel) {
      event.target.setAttribute("stroke-dasharray", "");
    }
  }

  onDelete(event) {
    if (!this.state.isDraw && this.state.isDel) {
      let id = event.target.getAttribute("id");
      let newLists = this.state.listItemSvg.filter((obj) => obj.id != id);
      this.setState({
        listItemSvg: newLists,
      });
    }
  }
  setOption = () => {
    const { currentAnimationId, animationSelectCurrent } = this.props;
    if (currentAnimationId !== animationSelectCurrent) {
      this.fetchCurrentAnimation()
    }
  }

  handleOutsideClick = (e) => {
    if (!this.nodeModalVersion.contains(e.target)) {
      this.setOption();
    }
  };

  fetchCurrentAnimation = () => {
    const { setCurrentAnimation } = this.props;
    this.setState({ isShowModalNotCompareVersion: false }, () => setCurrentAnimation())
  }

  scrollImage = (image, {x, y}) => {
    // scroll in image
    const { isMarking, startX, startY } = this.state;
    const { max, abs } = Math;
    if (startY >= y || y - startY <= 100 || !isMarking ) return
    let playerRect = findDOMNode(image).getBoundingClientRect();
    let maxHeightImage = 10000;
    /* FIX 20260831-autoscroll 範囲指定の自動スクロール。
       (1)★PDFは setTimeout に渡した通常関数の中で this.getWrapCenter() を呼んでおり、
          通常関数では this が失われるため、呼ばれた瞬間に必ず落ちて一度も動いていなかった。
          画像側は document.getElementById を使うため this を使わず、正常に動いていた。
       (2)★「重い」の正体。debounceTimer が関数の中の変数のため clearTimeout が効かず、
          さらに100ms待つため、マウスを動かした回数ぶんしか進まず、
          端で手を止めると完全に止まっていた。待ちをやめてその場で動かす。
       (3)★端に近いほど速くする。速さは TM_SCROLL_MAX の数字だけで調整できる。
       発動条件(下方向へ100px以上・isMarking)と、上下左右の判定式は1つも変えていない。
       通信・DB・外部通信はいずれも0回。画面の中でスクロール位置を動かすだけ。 */
    var TM_SCROLL_MIN = 3;
    var TM_SCROLL_MAX = 24;
    var element = document.getElementById("wrap-center");
    if (!element) return;
    var mouseX = max(x - startX, 0) - element.offsetLeft;
    var mouseY = max(y - startY, 0) - element.offsetTop;
    var distanceFromTop = mouseY;
    var distanceFromLeft = mouseX;
    var distanceFromRight = element.offsetWidth - mouseX;
    var scrollX = 0;
    var scrollY = 0;
    var speedY = TM_SCROLL_MIN;
    var newY = (y * playerRect.height / 10000) + playerRect.top;
    var windowHeight = window.innerHeight;
    var scrollThreshold = (3 / 4) * windowHeight;
    /* ★上方向の判定を、下方向と同じ「画面上の座標」に揃える。
       元は distanceFromTop(=開始点から何px下か)で見ており、画面のどこに居るかを
       見ていなかったため、上方向は一度も成立していなかった。
       囲っている最中に画面の上へ隠れた開始点まで戻れるようにするためのもので、
       赤枠を上へ広げる話ではない(入口の startY >= y の条件は1文字も変えていない)。 */
    var scrollThresholdTop = (1 / 4) * windowHeight;
    if (newY <= scrollThresholdTop) {
      scrollY = -1;
      var roomT = scrollThresholdTop;
      var ratioT = roomT > 0 ? Math.min(Math.max((scrollThresholdTop - newY) / roomT, 0), 1) : 0;
      speedY = TM_SCROLL_MIN + (TM_SCROLL_MAX - TM_SCROLL_MIN) * ratioT;
    } else if (newY >= scrollThreshold) {
      scrollY = 1;
      var room = windowHeight - scrollThreshold;
      var ratio = room > 0 ? Math.min(Math.max((newY - scrollThreshold) / room, 0), 1) : 0;
      speedY = TM_SCROLL_MIN + (TM_SCROLL_MAX - TM_SCROLL_MIN) * ratio;
    }
    if (distanceFromLeft < TM_SCROLL_MIN) {
      scrollX = -1;
    } else if (distanceFromRight < TM_SCROLL_MIN) {
      scrollX = 1;
    }
    /* ★iPad(iOS Safari)では、-webkit-overflow-scrolling が効いている枠に対して
       scrollBy が無視されることを実機で確認した(枠はスクロール可能量15134あるのに
       scrollBy(0,50) の後も scrollTop が0のまま)。
       scrollTop / scrollLeft を直接書き換える形にすればPC・iPadとも動く。
       動かす量・向き・判定は1つも変えていない。 */
    if (scrollY !== 0) element.scrollTop  = element.scrollTop  + (scrollY * speedY);
    if (scrollX !== 0) element.scrollLeft = element.scrollLeft + (scrollX * TM_SCROLL_MIN);
  }

  GoogleDriveFileId(url){
    return getGoogleDriveFileId(url);
  }

  toggle = bool => name => {
    this.setState({ [`shouldShow${name}`]: bool });
  }
  open = this.toggle(true)
  close = this.toggle(false)

  fadeInLoader = () => {
    $('.preloader').fadeIn();
    setInterval(() => {
      $('.preloader').css('opacity', 0.2)
    }, 200);
  }
  startLoading = loadingText => {
    this.fadeInLoader();
    this.setState({ loadingText, isLoading: true });
  }

  endLoading = () => {
    this.setState({ loadingText: null, isLoading: false });
    $('.preloader').fadeOut();
  }

  isTouchInsidePlayer = (event) => {
    if (!event || !event.touches || !event.touches[0] || !this.image) return true;
    const imageRect = findDOMNode(this.image).getBoundingClientRect();
    const touchX = event.touches[0].clientX;
    const touchY = event.touches[0].clientY;
    return (
      touchX >= imageRect.left &&
      touchX <= imageRect.right && 
      touchY >= imageRect.top &&
      touchY <= imageRect.bottom
    );
  }

  render() {
    const { src, downloadUrl, animationMarkerCreationPath, markers, markerCreatable, onClickDownloadButton, mobile,
      onMarkerUpdationCalled, updateMakerShow, currentUserId, role, owner, changeCss, user, scaleImage,
      animationSelectCurrent, currentAnimationId, onMarkerDeletionCalled, reloadMarkers, apiClient,
      currentAnimation, deleteReplyMarker, avatarUrl, project, is_project_owner_member
    } = this.props;
    const { currentX, currentY, currentWidth, currentHeight, currentShape, shouldShowForm, markersVisibility,
            isMarking, temp, isShowModalNotCompareVersion, timestamp, shouldShowGdriveFileDeletedModal
          } = this.state;
    let src2 = ''
    let additionalInfo = currentAnimation?.additional_info;
    if(additionalInfo && additionalInfo?.gdrive_image && additionalInfo.gdrive_pdf == undefined) {
      const driveID = this.GoogleDriveFileId(src);
      src2 = `https://lh3.googleusercontent.com/d/${driveID}` 
    } else {
      const encodeName = src.split('/').pop()
      const decodeName = decodeURI(decodeURI(encodeName));
      src2 = `${src.replace(encodeName, decodeName)}?v=${timestamp}`
    }

    var preview = <img src={src} alt='logo' />;
    return (
      <div
        id="wrap-center"
        style={{minHeight:"90%"}}
        className={`wrap-animation-preview ${mobile ? 'wrap-animation-preview-image-for-mobile' : ''} ${getStyleOfSize(scaleImage,"wrap")}`}>
        <div
          className="animation-preview"
          id="animation-preview"
          style={{width:`${scaleImage}%`}}
          ref={(ref) => (this.wrap = ref)}
        >
          <div
            className={classnames('animation-image', { marking: isMarking })}
            id="animation-image"
          >
            <div className='project__image' ref={ref => this.image = ref} id="project__image">
              <img
                crossOrigin="anonymous" onLoad={this.onImgLoad} src={src2}
                alt='logo' id="img" ref={(ref) => (this.img = ref)}
              />
            </div>
            <canvas
                id="canvas"
                ref={(ref) => (this.canvas = ref)}
                width={`${this.state.canvasWidth}px`}
                height={`${this.state.canvasHeight}px`}
                style={Object.assign({}, styles.canvas, {zIndex: this.state.zIndexSvg})}
              ></canvas>
              {/* {
                scaleImage !== 100 &&
                <div style={Object.assign({}, styles.canvas, {
                  zIndex: this.state.zIndexSvg + 1,
                })}>
              </div>
              } */}
              <div
                ref={(ref) => (this.drawSvg = ref)}
                className="draw-svg"
                style={{
                  zIndex: this.state.zIndexSvg,
                  touchAction: (this.props.isCommentMode) ? 'none' : 'auto',
                }}
                onMouseDown={(event) => this.onMouseDown(event, false)}
                onMouseMove={(event) => this.onMouseMove(event, false)}
                onMouseUp={() => this.onMouseUp()}
                onMouseLeave={() => this.onMouseUp()}
                onTouchStart={(event) => this.onMouseDown(event, true)}
                onTouchEnd={() => this.onMouseUp()}
                onTouchMove={(event) => this.onMouseMove(event, true)}
              >
                <svg
                  preserveAspectRatio="none"
                  viewBox={`0 0 ${this.state.canvasWidth} ${this.state.canvasHeight}`}
                  className={this.state.isDel ? 'cursor_eraser': `cursor_pencil_${this.state.settingDraw.color}`}
                  width={`${this.state.canvasWidth}px`}
                  height={`${this.state.canvasHeight}px`}
                  ref={(ref) => (this.svg = ref)}
                  style={Object.assign(
                    {},
                    styles.canvas,
                    { zIndex: this.state.zIndexSvg },
                  )}
                >
                  {this.state.listItemSvg.map((item, i) => (
                    <PolyLineSvg
                      id={item.id}
                      points={item.points}
                      color={item.color}
                      lineWidth={item.lineWidth}
                      onItemMouseOver={(event) => this.onItemMouseOver(event)}
                      onItemMouseLeave={(event) => this.onItemMouseLeave(event)}
                      onDelete={(event) => this.onDelete(event)}
                    />
                  ))}
                </svg>
              </div>
            {
              !canUserNotPermission(role) && markerCreatable || !gon.is_login || this.props.isCommentMode ? ( <div
                className={changeCss ? 'overlay-fix' : 'overlay akapon'}
                onMouseDown={(event) => {
                  if (this._touchHandled) return;
                  event.stopPropagation();
                  event.preventDefault();
                  const now = Date.now();
                  const delta = now - this._lastTapTime;
                  this._lastTapTime = now;
                  if (delta < this._DOUBLE_TAP_MS && delta > 0) {
                    this._lastTapTime = 0;
                    if (!this.props.isCommentMode) {
                      this._showCommentMode();
                      this._showModeToast('コメントモードに切り替わりました');
                    }
                    return;
                  }
                  if (!this.props.isCommentMode) {
                    this._showTapHint();
                    return;
                  }
                  this.disableMmount('none');
                  const [x, y] = this.mouseRelativeXY(event);
                  this.startMark({ x, y });
                }}
                onTouchStart={(event) => {
                  console.log('[DEBUG] overlay onTouchStart called');
                  this._touchHandled = true;
                  setTimeout(() => { this._touchHandled = false; }, 500);
                  event.stopPropagation();
                  event.preventDefault();
                  this.setOption();
                  const now = Date.now();
                  const delta = now - this._lastTapTime;
                  this._lastTapTime = now;
                  if (delta < this._DOUBLE_TAP_MS && delta > 0) {
                    this._lastTapTime = 0;
                    if (!this.props.isCommentMode) {
                      this._showCommentMode();
                      this._showModeToast('コメントモードに切り替わりました');
                    }
                    return;
                  }
                  if (!this.props.isCommentMode) {
                    this._showTapHint();
                    return;
                  }
                  const [x, y] = this.touchRelativeXY(event);
                  this.startMark({ x, y });
                }}
                onMouseMove={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  const [x, y] = this.mouseRelativeXY(event);
                  this.moveMark({ x, y });
                  this.scrollImage(this.image, {x, y});
                }}
                onTouchMove={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  /* FIX 20260831-touchscroll 指の操作を、マウスと同じ作りに揃える。
                     (1)指がメディアの外へ出た瞬間に endMark していたため、下まで囲おうとすると
                        その場で囲いが確定してコメントBOXが開き、続きを囲えなかった。
                        マウス側は外へ出ても囲いが続く作りで、PCでは従来から下まで囲えている。
                        指を離せば onTouchEnd / onTouchCancel で必ず確定するため、囲いっぱなしにはならない。
                     (2)scrollImage がマウス側からしか呼ばれておらず、指では自動スクロールが
                        一度も動いていなかった。マウス側と同じ位置で呼ぶ。
                     moveMark・startMark・endMark・座標の変換はいずれも1文字も変更していない。
                     動画とYouTube(AnimationPlayer / ShowEmbedVideos)は別ファイル・別実装のため無関係。 */
                  const [x, y] = this.touchRelativeXY(event);
                  this.moveMark({ x, y });
                  this.scrollImage(this.image, {x, y});
                }}
                onMouseUp={this.endMark}
                onTouchEnd={this.endMark}
                onTouchCancel={this.endMark}
                onClick={this.setOption}
              >
              </div>) : ( <div />)
            }
            {
              isMarking && <MarkShape x={currentX} y={currentY} width={currentWidth} height={currentHeight} shape={currentShape} />
            }
            <AnimationMarkersInPlayer
              markers={markers} visibility={markersVisibility} order={11}
              onMarkerUpdationCalled={onMarkerUpdationCalled} image={this.image}
              updateMakerShow={updateMakerShow}
            />
            {
              shouldShowForm && (
                <AnimationMarkerForm
                  x={currentX} y={currentY} width={currentWidth} height={currentHeight}
                  shape={currentShape} onSubmit={this.onSubmitMarkerForm}
                  onClickClose={this.onCloseMarkerForm} order={12} mobile={mobile}
                  shouldShowForm={shouldShowForm} currentUserId={currentUserId} role={role} owner={owner} user={user}
                  scaleImage={scaleImage}
                  ref={(ref) => (this.makerForm = ref)}
                  is_embed_video={false}
                  is_show_draw_component={true}
                />
              )
            }
            
          </div>
        </div>
        <CommentDetail
          selectedMarker={this.props.selectedMarker}
          updateSelectedMarker={this.props.updateSelectedMarker}
          onMarkerUpdationCalled={onMarkerUpdationCalled}
          currentUserId={currentUserId}
          owner={owner}
          role={role}
          animationSelectCurrent={animationSelectCurrent}
          currentAnimationId={currentAnimationId}
          onMarkerDeletionCalled={onMarkerDeletionCalled}
          reloadMarkers={reloadMarkers}
          apiClient={apiClient}
          markers={markers}
          deleteReplyMarker={deleteReplyMarker}
          avatarUrl={avatarUrl}
          shouldShowForm={shouldShowForm}
          is_project_owner_member={is_project_owner_member}
        />
        <div ref={nodeModalVersion => { this.nodeModalVersion = nodeModalVersion }}>
          <Modal isOpen={isShowModalNotCompareVersion}
               className="animation-uploader-modal modal-dialog-centered modal-not-compare-version "
               size="md" >
            <ModalBody>
              <div className='text-center text-black'>
                <div className='font-size-of-modal-not-compare font-weight-bold text-black text-center'>
                  <span>メディア画面とコメントツールの </span>
                  <span>バージョンが異なる為、赤入れできません。</span>
                </div>
                <Button className="btn btn-danger my-2 button-set-current-animation" onClick={this.fetchCurrentAnimation}>
                  表示中のメディア画面を赤入れする
                </Button>
                <span class="text-of-current-title">
                  ※クリックするとコメントツールのバージョンが{currentAnimation.final ? '最終稿' : currentAnimation.title}に変わります。
                </span>
              </div>
            </ModalBody>
          </Modal>
        </div>

        <GdriveFileDeletedModal
          isOpen={shouldShowGdriveFileDeletedModal}
          onClickClose={this.close.bind(this, 'GdriveFileDeletedModal')}
          apiClient={apiClient}
          currentAnimationId={currentAnimationId}
          currentAnimation={currentAnimation}
          onStart={this.startLoading.bind(this, 'Now Processing...')}
          endLoading={this.endLoading}
          type='pdf'
          project={project}
          applyAllGdrive={this.props.applyAllGdrive}
          canUseApplyAll={this.props.canUseApplyAll}
          defaultGdriveLogic={this.props.defaultGdriveLogic}
        />
        <NavLink href="#!" className='hidden d-none' id="gdriveFileDeletedModal" onClick={this.open.bind(this, 'GdriveFileDeletedModal')}>
        </NavLink>
      </div>
    )
  }
}
